import { ApplicationEnvironment, TargetEnvironment } from './environment.interface';

export const environment: ApplicationEnvironment = {
    targetEnvironment: TargetEnvironment.Default,
    launchDarklyConfig: {
        clientId: '664590c02c638010dc55095f'
    },
    abstractionLayerConfig: {
        stagingUri: 'https://quobkvexmre7blsb7ltpdz2xxi.appsync-api.eu-north-1.amazonaws.com/graphql',
        releaseUri: 'https://quobkvexmre7blsb7ltpdz2xxi.appsync-api.eu-north-1.amazonaws.com/graphql'
    },
    authLayerConfig: {
        stagingUri: 'https://ehlfaue7jfexfalnchzbb672sq.appsync-api.eu-north-1.amazonaws.com/graphql',
        releaseUri: 'https://tfsusyfgjnaitctqbnqad3v2bq.appsync-api.eu-north-1.amazonaws.com/graphql',
    },
    logConfig: {
        application: 'driving-restrictions',
        env: 'dev',
        graphqlUrl: 'https://kftht5tfp5b6tfwm6kzqa7ijzu.appsync-api.eu-north-1.amazonaws.com/graphql',
        logLevel: 2,
        console: true,
        debounceTime: 5000,
    },
    colaConfig: {
        redirectUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com/login'
    },
    environmentName: 'Test',
    flags: {
        staging: 'staging',
    },
    params: {
        oneTimeToken: 'fenixOneTimeToken'
    }

};
